export  const TipoNormativoEnum = {
    ATO_REGULAMENTAR : {text:"Ato Regulamentar",value:"Ato Regulamentar"},  
    EMENDA_REGIMENTAL: {text:"Emenda Regimental",value:"Emenda Regimental"},    
    INSTRUCAO_NORMATIVA: {text:"Instrução Normativa",value:"Instrução Normativa"},
    MANUAL_ORGANIZACAO: {text:"Manual de Organização",value:"Manual de Organização"},    
    ORDEM_SERVICO: {text:"Ordem de Serviço (1999-2003)",value:"Ordem de Serviço"},
    PORTARIA: {text:"Portaria",value:"Portaria"},
    PORTARIA_CONJUNTA_GP: {text:"Portaria Conjunta (GP)",value:"Portaria Conjunta (GP)"},    
    PROCEDIMENTO_JUDICIARIO: {text:"Procedimento Judiciário",value:"Procedimento Judiciário"},
    REGIMENTO_INTERNO: {text:"Regimento Interno",value:"Regimento Interno"},
    REGULAMENTO_SECRETARIA: {text:"Regulamento da Secretaria",value:"Regulamento da Secretaria"},
    RESOLUCAO: {text:"Resolução",value:"Resolução"},
    RESOLUCAO_CONJUNTA: {text:"Resolução Conjunta",value:"Resolução Conjunta"},   
    VAZIO_1: {text:"",value:""},   
    VAZIO_2: {text:"",value:""},   
    
    AVISO : {text:"Aviso",value:"Aviso"},
    DECRETO_LEI : {text:"Decreto-Lei",value:"Decreto-Lei"},  
    LEI: {text:"Lei",value:"Lei"},
}
export default TipoNormativoEnum;

